import { useState, useEffect } from 'react';
import './Contact.css';

// 👇 Pega aquí tu endpoint de Formspree
const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xreyaplv';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  // Hook para obtener parámetros de URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const serviceParam = urlParams.get('service');
    if (serviceParam) {
      setFormData(prev => ({
        ...prev,
        service: serviceParam
      }));
    }
  }, []);

  // Hook para animaciones
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in--visible');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.fade-in').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // Servicios disponibles
  const services = [
    'Transformación Digital',
    'Inteligencia Artificial',
    'Cloud Computing',
    'Ciberseguridad',
    'Gestión Estratégica',
    'Implementación de Sistemas de Gestión',
    'Capacitación',
    'Asesoría en Certificaciones',
    'Consultoría General',
    'Otro'
  ];

  // Información de contacto
  const contactInfo = [
    {
      icon: '📧',
      title: 'Email',
      value: 'info@isqsservices.mx',
      action: () => window.open('mailto:hola@isqsservices.mx')
    },
  ];

  // Redes sociales
  const socialLinks = [
    { icon: '💼', name: 'LinkedIn', url: 'https://www.linkedin.com/in/servio-reyes-mar-53362822/' },
  ];

  // Manejar cambios en el formulario
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Manejar envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          company: formData.company,
          service: formData.service,
          message: formData.message,
        }),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', company: '', service: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(''), 6000);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero__content fade-in">
            <span className="contact-hero__eyebrow">Estamos aquí para ayudarte</span>
            <h1 className="contact-hero__title">
              ¡Hablemos de tu <span className="contact-hero__title-gradient">Proyecto!</span>
            </h1>
            <p className="contact-hero__subtitle">
              Estamos listos para transformar tu empresa. Cuéntanos sobre tus desafíos y objetivos.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Main */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-grid">
            {/* Formulario de contacto */}
            <div className="contact-form-section fade-in">
              <div className="contact-form-header">
                <h2 className="contact-form__title">Envíanos un mensaje</h2>
                <p className="contact-form__subtitle">
                  Responderemos a tu consulta en menos de 24 horas
                </p>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">Nombre completo *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="Tu nombre completo"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email" className="form-label">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="tu@email.com"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone" className="form-label">Teléfono</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="+52 (55) 1234-5678"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="company" className="form-label">Empresa</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      className="form-input"
                      placeholder="Nombre de tu empresa"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="service" className="form-label">Servicio de interés</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="">Selecciona un servicio</option>
                    {services.map((service, index) => (
                      <option key={index} value={service}>{service}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">Mensaje *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="form-textarea"
                    placeholder="Cuéntanos sobre tu proyecto, necesidades específicas o cualquier pregunta que tengas..."
                    rows="6"
                    required
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className={`form-submit ${isSubmitting ? 'form-submit--loading' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                </button>

                {submitStatus === 'success' && (
                  <div className="form-status form-status--success">
                    ✅ ¡Mensaje enviado exitosamente! Te contactaremos pronto.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="form-status form-status--error">
                    ❌ Error al enviar el mensaje. Por favor intenta nuevamente.
                  </div>
                )}
              </form>
            </div>

            {/* Información de contacto */}
            <div className="contact-info-section fade-in">
              <div className="contact-info">
                <h3 className="contact-info__title">Información de contacto</h3>
                <p className="contact-info__subtitle">
                  También puedes contactarnos directamente a través de:
                </p>

                <div className="contact-info__items">
                  {contactInfo.map((item, index) => (
                    <div 
                      key={index} 
                      className={`contact-info__item ${item.action ? 'contact-info__item--clickable' : ''}`}
                      onClick={item.action}
                    >
                      <div className="contact-info__icon">{item.icon}</div>
                      <div className="contact-info__content">
                        <h4 className="contact-info__item-title">{item.title}</h4>
                        <p className="contact-info__item-value">{item.value}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="contact-social">
                  <h4 className="contact-social__title">Síguenos en redes</h4>
                  <div className="contact-social__links">
                    {socialLinks.map((social, index) => (
                      <a 
                        key={index}
                        href={social.url}
                        className="contact-social__link"
                        title={social.name}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="contact-social__icon">{social.icon}</span>
                        <span className="contact-social__name">{social.name}</span>
                      </a>
                    ))}
                  </div>
                </div>

                {/* Mapa placeholder */}
              
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="contact-faq">
        <div className="container">
          <div className="contact-faq__header fade-in">
            <h2 className="contact-faq__title">Preguntas Frecuentes</h2>
            <p className="contact-faq__subtitle">
              Resuelve tus dudas antes de contactarnos
            </p>
          </div>

          <div className="faq-grid">
            <div className="faq-item fade-in">
              <h3 className="faq-question">¿Cuánto tiempo toma implementar una solución?</h3>
              <p className="faq-answer">
                Depende del alcance del proyecto. Los proyectos simples pueden tomar 1-3 meses, 
                mientras que implementaciones complejas pueden requerir 6-12 meses.
              </p>
            </div>

            <div className="faq-item fade-in">
              <h3 className="faq-question">¿Ofrecen soporte post-implementación?</h3>
              <p className="faq-answer">
                Sí, ofrecemos soporte continuo 24/7 y programas de mantenimiento para 
                asegurar el óptimo funcionamiento de todas nuestras soluciones.
              </p>
            </div>

            <div className="faq-item fade-in">
              <h3 className="faq-question">¿Trabajan con empresas de todos los tamaños?</h3>
              <p className="faq-answer">
                Absolutamente. Tenemos experiencia trabajando con startups, PyMEs y 
                grandes corporaciones en diversos sectores industriales.
              </p>
            </div>

            <div className="faq-item fade-in">
              <h3 className="faq-question">¿Cómo garantizan la calidad de sus servicios?</h3>
              <p className="faq-answer">
                Contamos con certificaciones ISO y seguimos metodologías internacionales 
                reconocidas. Además, ofrecemos garantías en todos nuestros proyectos.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;